import Component from '../core/Component';
import enquire from 'enquire.js';
import { queries } from '../core/config';

import { toggleClass } from '../utils/dom';

const ACTIVE = 'is-active';

export default class ClassToggle extends Component {

    constructor(element) {
        super(element);
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick);
    }

    handleClick(event) {
        let element = event.toElement;

        if (element !== undefined && element !== null) {

            let ignoreToggle = element.getAttribute('data-ignore-toggle');

            if (ignoreToggle === null) {
                event.preventDefault();
            }
        }

        this.element.classList.toggle(ACTIVE);
    }
}
